import ResumeSubscriptionConfirmationPopup from 'components/layout/ResumeSubscriptionConfirmationPopup';
import SnoozeSubscriptionPopup from 'components/layout/SnoozeSubscriptionPopup';
import { SNOOZE_DURATION_OPTIONS } from 'components/subscriptions/SnoozeSubscriptionSection';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

const SnoozeSwitchSection = observer(
  ({
    style,
    SwitchComponent,
  }: {
    style?: React.CSSProperties;
    SwitchComponent: React.FC<any>;
  }) => {
    
    const { activeSubscriptions, fetchSubscriptions } = useUserStore();
    const subscription = activeSubscriptions[0];


    const [showConfirmSnoozePopup, setShowConfirmSnoozePopup] =
      useState<boolean>(false);
    const [
      showResumeSubscriptionConfirmationPopup,
      setShowResumeSubscriptionConfirmationPopup,
    ] = useState<boolean>(false);
    const snoozeSwitchEnabled = subscription?.subscription.status === 'SNOOZED';

    const handleToggleToSnooze = async () => {
      if (!subscription) return;
      setShowConfirmSnoozePopup(true);
    };

    const handleToggleToResume = async () => {
      if (!subscription) return;
      setShowResumeSubscriptionConfirmationPopup(true);
    };

    if (!subscription) return null;

    return (
      <div className="container" style={style}>
        {/* Snooze Subscription Popup */}
        {showConfirmSnoozePopup && (
          <SnoozeSubscriptionPopup
            subscriptionId={subscription.subscription.id}
            onClose={() => setShowConfirmSnoozePopup(false)}
            onSuccess={async () => {
              setShowConfirmSnoozePopup(false);
              await fetchSubscriptions();
            }}
          />
        )}
        {/* Resume Subscription Popup */}
        {showResumeSubscriptionConfirmationPopup && (
          <ResumeSubscriptionConfirmationPopup
            subscriptionId={subscription.subscription.id}
            onClose={() => setShowResumeSubscriptionConfirmationPopup(false)}
            onSuccess={async () => {
              setShowResumeSubscriptionConfirmationPopup(false);
              await fetchSubscriptions();
            }}
          />
        )}

        <SwitchComponent
          subscription={subscription}
          snoozeSwitchEnabled={snoozeSwitchEnabled}
          handleToggleToResume={handleToggleToResume}
          handleToggleToSnooze={handleToggleToSnooze}
          validSnoozeDurationsForSubscription={SNOOZE_DURATION_OPTIONS}
        />

        <style jsx>
          {`
            .container {
              display: flex;
              align-items: flex-start;
            }

            .activeSide,
            .snoozedSide {
              display: flex;
              align-items: center;
              margin-top: 0.7em;
            }

            .heading {
              text-transform: uppercase;
              font-weight: bold;
              font-size: 0.8rem;
              margin-bottom: 0;
            }

            .subheading {
              font-size: 0.6rem;
              font-style: italic;
            }
          `}
        </style>
      </div>
    );
  }
);

export default SnoozeSwitchSection;
